import { shareEntityButtonStyles } from "@insite/content-library/Components/ShareEntityButton";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(shareEntityButtonStyles, {
    button: buttonStyle.cancelButton,
    cancelButton: buttonStyle.cancelButton,
    sendButton: buttonStyle.continueButton,
});
